import { Component, OnInit, Input, OnDestroy, OnChanges, SimpleChanges, Output, EventEmitter, AfterContentInit, DoCheck } from '@angular/core';

import { FechasService } from 'src/app/services/fechas/fechas';
import { ImprimiService } from 'src/app/services/imprimir/imprimirService';
import { FirmaService } from 'src/app/services/firma/firmaService';
import { estilos_informes } from 'src/app/config/estilos-informes';

declare var $: any;



@Component({
    selector: 'app-imprimi-tirita',
    templateUrl: './imprimirTirita.component.html',
    styleUrls: ['./imprimirTirita.component.css'],
    providers: [ImprimiService, FirmaService]

})

export class ImprimirTiritasComponent implements OnInit, OnDestroy, OnChanges {

    @Input() title: string;
    @Input() id: string;
    @Input() database: string;
    @Output() cerrarVentana = new EventEmitter();


    public anexo = new Date();
    public productos: any = [];
    public oldId = "";
    public oldDatabase = "";
    public productosKey: any[] = [];
    public estructurado: any[] = [];
    public fechaActual = this.fechaService.mostrarFechaActual();
    public closeWindow = true;
    public firma = "";
    public baseUrl = "https://traza-brio.com/calidad/ws/upload/firmas/";
    public nombre = '';
    public loading = true;
    public firma_revision: string;
    public procedimiento: string = 'x';
    public numero_anexo: string = 'x';
    public fecha: any = []; 
    public field: string = 'tiritas'; 

    constructor(
        private fechaService: FechasService,
        private imprimirService: ImprimiService,
        private firmaService: FirmaService) {
        this.oldId = this.id;

    }
    public myMap = new Map([]);
    ngOnInit(): void {

        this.mostrarContenido();


    }
    ngOnDestroy(): void {

    }
    ngOnChanges(changes: SimpleChanges) {
        // this.mostrarContenido();



    }

    mostrarContenido() {
        this.firma_revision = '';

        //console.log("id",this.id,"database",this.database);
        this.imprimirService.getId(this.id, this.database).subscribe((resp: any) => {

            this.productos = resp;
            //console.log(this.productos[0].encargada);

            this.nombre = this.productos[0].encargada;
            try {
                this.firmaService.getFirma(this.productos[0].encargada).toPromise().then((data: any) => {
                    //console.log(data);
                    if (data.productos[0].firma) {
                        this.firma = this.baseUrl + data.productos[0].firma;
    
                    } else {
                        //console.log("no hay firma");
    
                        this.firma = null;
                    }
    
                });
            } catch (error) {
                this.firma = null;
            }
            try {
                this.firmaService.getFirma(this.productos[0].revision).toPromise().then((data: any) => {
                     /* console.log('firma revisión ', data); */
                   
                    if (data ) {
                        if ( data.productos[0].firma ) {
                            this.firma_revision = this.baseUrl + data.productos[0].firma;
    
                        } else {
                            //console.log("no hay firma");
    
                            this.firma_revision = null;
                        }
                    } 
                    

                });
            } catch (error) {
                this.firma_revision = null;
            }
            //console.log("tiritas imprimir",this.productos[0]);

            let number = 0;
            for (const key in this.productos[0]) {
                this.productosKey.push([key]);

                let recogerPalabra = key;
                let recogercadenas = [];

                let separarFEcha = this.productos[0]['fecha'].split("/");

                let estructurarFEcha = separarFEcha[2] + "-" + separarFEcha[1] + "-" + separarFEcha[0];
                this.fecha = estructurarFEcha;
                //console.log("estructurarFEcha",estructurarFEcha);
                if (number == 0) {

                   /*  this.imprimirService.getAnexo(estructurarFEcha, this.database).subscribe(resp => {
                      

                        try {
                            if (resp[0]['fecha_anexo'] === undefined) {
                                this.anexo = new Date();
                            } else {
                                this.anexo = resp[0]['fecha_anexo'];
                            }
                        } catch (error) {
                            this.anexo = new Date();
                        }


                    }); */
                    number++;
                } else {

                }

            }

            this.loading = false;
        }, error => {
            console.log("error", error);
            this.loading = false;
        });

    }

    jsUcfirst(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    }


    Export2Doc() {
        //this.convertImagesToBase64();

        var preHtml = "<html xmlns:o='urn:schemas-microsoft-com:office:office' xmlns:w='urn:schemas-microsoft-com:office:word' xmlns='http://www.w3.org/TR/REC-html40'><head><meta charset='utf-8'><title>Export HTML To Doc</title>"
            + "<style>" + estilos_informes + "</style>"
            + "</head><body > <div style=' font-family: Arial !important;'>";
        var postHtml = "</div></body></html>";
        var html = preHtml + document.getElementById('source-html').innerHTML + postHtml;

        var blob = new Blob(['\ufeff', html], {
            type: 'application/msword'
        });

        // Specify link url
        var url = 'data:application/vnd.ms-word;charset=utf-8,' + encodeURIComponent(html);
        let filename = "";
        // Specify file name
        filename = filename ? filename + '.doc' : 'Control de tiritas.doc';

        // Create download link element
        var downloadLink = document.createElement("a");

        document.body.appendChild(downloadLink);

        if (navigator.msSaveOrOpenBlob) {
            navigator.msSaveOrOpenBlob(blob, filename);
        } else {
            // Create a link to the file
            downloadLink.href = url;

            // Setting the file name
            downloadLink.download = filename;

            //triggering the function
            downloadLink.click();
        }

        document.body.removeChild(downloadLink);
    }



    convertImagesToBase64() {

        var files = document.querySelectorAll("img");

        var canvas = document.createElement('canvas');
        var ctx = canvas.getContext('2d');
        canvas.setAttribute('crossOrigin', 'anonymous');

        for (let index = 0; index < files.length; index++) {
            const element = files[index];


            element.setAttribute('crossOrigin', 'anonymous');
            var img = new Image();
            img.crossOrigin = 'Anonymous';
            img.src = element.getAttribute("src");
            console.log("img", img.src);


            canvas.height = img.height;
            canvas.width = img.width;
            ctx.drawImage(img, 0, 0);
            let dataURL = canvas.toDataURL();
            console.log("dataurl", dataURL);






        }
        canvas.remove();


    }

    cerrar() {
        this.cerrarVentana.emit({ closeWindow: false });
    }

    convertImgToBase64URL(url, callback, outputFormat) {
        var img = new Image();
        img.crossOrigin = 'Anonymous';
        img.onload = function () {
            var canvas = document.createElement('canvas'),
                ctx = canvas.getContext('2d'), dataURL;
            canvas.height = img.height;
            canvas.width = img.width;
            ctx.drawImage(img, 0, 0);
            dataURL = canvas.toDataURL(outputFormat);
            callback(dataURL);
            canvas = null;
        };
        img.src = url;
    }


    getBase64(file) {
        var reader = new FileReader();
        let myfile = new Blob();
        let objectURL = URL.createObjectURL('object');
        reader.readAsDataURL(myfile);
        reader.onload = function () {
            console.log(reader.result);
        };
        reader.onerror = function (error) {
            console.log('Error: ', error);
        };
    }



}